import { Color } from '@persona-id/design-tokens';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { TransitionDuration } from 'design-system/variables/transitions';

interface AboveFrameHintProps {
  text: string | null | undefined;
}

const AboveFrameHintContainer = styled.div<{ visible: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -16px;
  transform: translateY(-100%);
  border-radius: 4px;
  padding: 8px 16px;
  background-color: rgba(255, 255, 255, 0.15);
  color: ${Color.PrimaryWhite};
  width: 100%;
  text-align: center;
  font-size: 14px;
  line-height: 150%;
  z-index: 1;

  transition: opacity ${TransitionDuration.Fast};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
`;

const AboveFrameHint = ({ text }: AboveFrameHintProps) => {
  // remember the last time the text was set so that the div does not collapse while fading out
  const [lastText, setLastText] = useState('');

  useEffect(() => {
    if (text) {
      setLastText(text);
    }
  }, [text]);

  return (
    <AboveFrameHintContainer visible={!!text}>
      <div role='alert'>{text || lastText}</div>
    </AboveFrameHintContainer>
  );
};

export default AboveFrameHint;
